import { render, staticRenderFns } from "./leverage-margin.vue?vue&type=template&id=6a771ca3&scoped=true&"
import script from "./leverage-margin.vue?vue&type=script&lang=js&"
export * from "./leverage-margin.vue?vue&type=script&lang=js&"
import style0 from "./leverage-margin.vue?vue&type=style&index=0&id=6a771ca3&scoped=true&lang=css&"
import style1 from "./leverage-margin.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a771ca3",
  null
  
)

export default component.exports